var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "22px",
    height: "22px",
    viewBox: "0 0 22 22",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Close") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Assets",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "1920x1080",
    transform: "translate(-432.000000, -87.000000)",
    fill: "#000000",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Close",
    transform: "translate(432.000000, 87.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Shape",
    points: "15.4030779 6.02401649 15.9687633 6.58970192 11.561 10.996 15.9687633 15.4030779 15.4030779 15.9687633 10.996 11.561 6.58970192 15.9687633 6.02401649 15.4030779 10.431 10.996 6.02401649 6.58970192 6.58970192 6.02401649 10.996 10.431"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11,0.628880866 C5.27218906,0.628880866 0.628880866,5.27218906 0.628880866,11 C0.628880866,16.7278109 5.27218906,21.3711191 11,21.3711191 C16.7278109,21.3711191 21.3711191,16.7278109 21.3711191,11 C21.3711191,5.27218906 16.7278109,0.628880866 11,0.628880866 Z M11,1.42888087 C16.2859831,1.42888087 20.5711191,5.71401686 20.5711191,11 C20.5711191,16.2859831 16.2859831,20.5711191 11,20.5711191 C5.71401686,20.5711191 1.42888087,16.2859831 1.42888087,11 C1.42888087,5.71401686 5.71401686,1.42888087 11,1.42888087 Z",
    id: "Oval"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.32eeffbc238a09a50205feb33fcf8d6f.svg";
export { ForwardRef as ReactComponent };